<template>
  <div class="section">
    <h2>
      <span class="section-title">{{ $t('delete_account.title') }}</span>
      <span class="section-description">{{ $t('delete_account.sub_title') }}</span>
    </h2>
    <div class="margin-top-30px">
      <p class="has-text-weight-bold">ファイル・サブスクリプション・ユーザー情報が全て削除されます</p>
    </div>
    <br>
    <button @click="deleteAccount" class="button is-info has-text-weight-bold">{{
      $t('delete_account.execute')
      }}
    </button>
    <button v-if="$store.state.stage !== 'production'" @click="cleanupAccount" id="cleanup" class="button">クリーンアップ
    </button>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import { useHead } from "@unhead/vue";

export default {
  name: 'DeleteAccount',
  created() {
    useHead({
      title: `${this.$t('delete_account.title')} | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        { name: 'description', content: appConfig[this.$i18n.locale].description.top },
        { name: 'robots', content: 'noindex,nofollow' }
      ]
    })
  },
  methods: {
    deleteAccount: function () {
      this.OpenLoading()

      this.$axios.delete(`/user`, { headers: { 'Authorization': `Bearer ${this.$store.state.token}` } }).then(() => {
        this.CloseLoading()
        this.$auth.logout({
          returnTo: window.location.origin
        })
      }).catch(err => {
        this.CloseLoading()
        this.$router.push({ name: 'Error', query: { title: 'エラーが発生しました', msg: err.response.data } }).catch(() => { })
      })
    },
    cleanupAccount: function () {
      this.$axios.get(`/user/cleanup`, { headers: { 'Authorization': `Bearer ${this.$store.state.token}` } }).then(() => {
        this.$buefy.dialog.alert('ok')
      }).catch(err => {
        this.$buefy.dialog.alert(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
